module.exports = __webpack_public_path__ + "img/er.1bf452ee.png";